import { HOME_COUNTERS } from "../content/siteContent";

export const COUNTER_LIST_TWO = [
  {
    id: 1,
    count: 95,
    suffix: "%",
    title: "Success Rate",
  },
  {
    id: 2,
    count: 55,
    suffix: "k",
    title: "Complete Projects",
  },
  {
    id: 3,
    count: 25,
    suffix: "k",
    title: "Satisfied Clients",
  },
  {
    id: 4,
    count: 15,
    suffix: "k",
    title: "Trade In The World",
  },
];

export const COUNTER_LIST_THREE = [
  {
    id: 1,
    count: 23,
    suffix: "k",
    icon: "flaticon-trophy",
    title: "Best Awards",
  },
  {
    id: 2,
    count: 223,
    suffix: "k",
    icon: "flaticon-rating",
    title: "Happy Clients",
  },
  {
    id: 3,
    count: 98,
    suffix: "k",
    icon: "flaticon-folder-1",
    title: "Projects Done",
  },
  {
    id: 4,
    count: 22,
    suffix: "k",
    icon: "flaticon-round-table",
    title: "Expert People",
  },
];

export const COUNTER_LIST_ONE = HOME_COUNTERS;
